module.exports = __webpack_public_path__ + "img/wasajon.0a433024.svg";